export default __webpack_public_path__ + "static/media/datascience.cabbf70d.jpg";